module.exports = __webpack_public_path__ + "img/apple-icon-precomposed.b4605707.png";